import React, { useEffect, useState } from "react";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import CommonApi from "../../../api/common.api";
import SaveBtn from "../../../component/atoms/button/saveBtn";
import Checkbox from "../../../component/atoms/input/checkbox";
import ImgInput from "../../../component/atoms/input/imgInput";
import MainInput from "../../../component/atoms/input/mainInput";
import Radio from "../../../component/atoms/input/radio";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import PretendardText from "../../../component/atoms/text/pretendardText";
import GoBack from "../../../component/molecules/goBack";
import ImgPreview from "../../../component/molecules/imgPreview";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import Modal from "../../../component/templates/Modal";
import { imgUrl } from "../../../constants/url";
import { isNull } from "../../../util/check";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";
import TextFormEditor from "../../../component/atoms/input/textFormEditor";
import DetailPageFormCol from "../../../component/atoms/layout/detail/detailPageFormCol";
import ColumnApi from "../../../api/column.api";

const ColumnPostEdit = () => {
  const navigate = useNavigate();
  let { id } = useParams();

  const [selectBoxOpen, setSelectBoxOpen] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState(-1);

  // mounted
  useEffect(() => {
    getColumnList();
    getCategory();
  }, []);

  // ----- 정보 가져오기
  const [columnInfo, setColumnInfo] = useState({
    title: "",
    content: "",
    viewCount: "",
    scrapCount: "",
    thumbnailOriginFileNameColumn: "",
    thumbnailServerFileNameColumn: "",
    thumbnailOriginFileNameMain: "",
    thumbnailServerFileNameMain: "",
  });

  const getColumnList = async () => {
    try {
      const response = (await ColumnApi.getPostById(id)).data.data.content;
      setColumnInfo(response);
      setSelectedCategory(response.columnCategory?.title);
      setSelectedCategoryId(response.columnCategory?.id);
    } catch (error) {
      errorHandler(error);
    }
  };

  const getCategory = async () => {
    try {
      let responseData = (await ColumnApi.getCategory({ size: 1000 })).data.data.content;

      setCategoryList(responseData.filter((item) => item.id !== 1));
    } catch (error) {
      errorHandler(error);
    }
  };

  const delImg = (type) => {
    if (type === "column") {
      setColumnInfo({
        ...columnInfo,
        fileColumn: "",
        fileUrlColumn: "",
        thumbnailOriginFileNameColumn: "",
        thumbnailServerFileNameColumn: "",
      });
    }
    if (type === "main") {
      setColumnInfo({
        ...columnInfo,
        fileMain: "",
        fileUrlMain: "",
        thumbnailOriginFileNameMain: "",
        thumbnailServerFileNameMain: "",
      });
    }
  };

  //이미지 추가, 삭제
  const inputFile = (e, type) => {
    const file = e.target.files[0];

    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = (value) => {
      if (type === "column") {
        setColumnInfo({
          ...columnInfo,
          fileColumn: file,
          fileUrlColumn: value.target.result,
        });
      }
      if (type === "main") {
        setColumnInfo({
          ...columnInfo,
          fileMain: file,
          fileUrlMain: value.target.result,
        });
      }
    };
    e.target.value = "";
  };

  //저장하기
  const [saveModalOpen, setSaveModalOpen] = useState(false);

  const saveBtnHandler = () => {
    if (
      isNull(columnInfo.title.trim()) ||
      (isNull(columnInfo.content.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim()) &&
        !/<img\b/i.test(columnInfo.content)) ||
      (!columnInfo.thumbnailServerFileNameColumn && !columnInfo.fileColumn) ||
      selectedCategoryId === -1
    ) {
      return toast("필수사항을 모두 입력해주세요.");
    }

    setSaveModalOpen(true);
  };

  const saveFunc = async () => {
    try {
      const data = {
        title: columnInfo.title.trim(),
        content: columnInfo.content,
        columnCategoryId: selectedCategoryId,
        activation: columnInfo.activation,
        mainFlag: columnInfo.mainFlag,
        thumbnailOriginFileNameColumn: columnInfo.thumbnailOriginFileNameColumn,
        thumbnailServerFileNameColumn: columnInfo.thumbnailServerFileNameColumn,
        thumbnailOriginFileNameMain: columnInfo.thumbnailOriginFileNameMain,
        thumbnailServerFileNameMain: columnInfo.thumbnailServerFileNameMain,
      };

      const [columnImage, mainImage] = await Promise.all([
        !isNull(columnInfo.fileUrlColumn)
          ? fileUpload(columnInfo.fileColumn)
          : null,
        !isNull(columnInfo.fileUrlMain) ? fileUpload(columnInfo.fileMain) : null,
      ]);

      if (columnImage) {
        data.thumbnailOriginFileNameColumn = columnImage.imageOriginFileName;
        data.thumbnailServerFileNameColumn = columnImage.imageServerFileName;
      }
      if (mainImage) {
        data.thumbnailOriginFileNameMain = mainImage.imageOriginFileName;
        data.thumbnailServerFileNameMain = mainImage.imageServerFileName;
      }

      await ColumnApi.updatePost(id, data);
      toast(toastMsg.update);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  // 파일 업로드
  const fileUpload = async (file) => {
    try {
      const response = (
        await CommonApi.getFileUploadUrl({
          path: "column",
          originalFileName: file.name,
          contentType: file.type || "application/octet-stream",
        })
      ).data.data;

      await CommonApi.cloudFileUpload(response.uploadUrl, file);

      return {
        imageOriginFileName: file.name,
        imageServerFileName: response.serverFileName,
      };
    } catch {
      const formData = new FormData();
      formData.append("path", "column");
      formData.append("file", file);

      try {
        const response = (await CommonApi.fileUpload(formData)).data.data;

        return {
          imageOriginFileName: file.name,
          imageServerFileName: response.serverFileName,
        };
      } catch (error) {
        errorHandler(error);
        throw error;
      }
    }
  };

  // 에디터
  const [isLoading, setIsLoading] = useState(false);

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
          </DetailTop>
          <DetailPage>
            <DetailPageTitle>수정하기</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>활성 상태*</DetailFormTitle>
                <div style={{ display: "flex", gap: "20px" }}>
                  <Radio
                    id={true}
                    name={"activation"}
                    valueText={"활성"}
                    checked={columnInfo.activation}
                    onChange={() => {
                      setColumnInfo({
                        ...columnInfo,
                        activation: true,
                      });
                    }}
                  />
                  <Radio
                    id={false}
                    name={"activation"}
                    valueText={"비활성"}
                    checked={!columnInfo.activation}
                    onChange={() => {
                      setColumnInfo({
                        ...columnInfo,
                        activation: false,
                      });
                    }}
                  />
                </div>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>대표 지정</DetailFormTitle>
                <CheckboxWrapper>
                  <Checkbox
                    id="representative"
                    checked={columnInfo.mainFlag}
                    onChange={() => {
                      setColumnInfo({
                        ...columnInfo,
                        mainFlag: !columnInfo.mainFlag,
                      });
                    }}
                  />
                  <DetailFormText>대표</DetailFormText>
                </CheckboxWrapper>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>작성일</DetailFormTitle>
                <DetailFormText>
                  {moment(columnInfo.createdAt).format("YYYY/MM/DD")}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>조회수</DetailFormTitle>
                <DetailFormText>{columnInfo.viewCount}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>스크랩</DetailFormTitle>
                <DetailFormText>{columnInfo.scrapCount}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>카테고리*</DetailFormTitle>
                <div>
                  <div style={{ position: "relative", width: "338px" }}>
                    <SelectBoxWrapper
                      onClick={() => {
                        setSelectBoxOpen(!selectBoxOpen);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <PretendardText
                        style={{
                          color: "#262C31",
                          fontSize: "15px",
                          fontWeight: "400",
                          lineHeight: "21.25px",
                        }}
                      >
                        {selectedCategory || "카테고리를 선택해주세요."}
                      </PretendardText>
                      <img
                        src="/assets/admin/icons/ico_select_arrow_down.svg"
                        alt=""
                      />
                    </SelectBoxWrapper>
                    {selectBoxOpen ? (
                      <SubMenuWrapper>
                        {categoryList.map((item, index) => {
                          return (
                            <SubMenuTextWrapper
                              key={index}
                              onClick={() => {
                                setSelectBoxOpen(false);
                              }}
                            >
                              <PretendardText
                                style={{
                                  color: "#262C31",
                                  fontSize: "15px",
                                  fontWeight: "500",
                                  lineHeight: "21.5px",
                                }}
                              >
                                {item.title}
                              </PretendardText>
                              {selectedCategory === item.title ? (
                                <img
                                  src="/assets/admin/icons/ico_select_checked.svg"
                                  alt=""
                                />
                              ) : null}
                            </SubMenuTextWrapper>
                          );
                        })}
                      </SubMenuWrapper>
                    ) : null}
                  </div>
                </div>
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>
                  칼럼 페이지 썸네일*
                  <br />
                  (권장사이즈 380*480)
                </DetailFormTitle>
                {columnInfo.thumbnailServerFileNameColumn ||
                columnInfo.fileUrlColumn ? (
                  <ImgPreview
                    fileUrl={
                      columnInfo.fileUrlColumn
                        ? columnInfo.fileUrlColumn
                        : imgUrl + columnInfo.thumbnailServerFileNameColumn
                    }
                    onClick={() => {
                      delImg("column");
                    }}
                  />
                ) : (
                  <ImgInput
                    id={"file"}
                    accept={"image/*"}
                    onChange={(e) => {
                      inputFile(e, "column");
                    }}
                  />
                )}
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>
                  메인페이지 썸네일
                  <br />
                  (권장사이즈 585*222)
                </DetailFormTitle>
                {columnInfo.thumbnailServerFileNameMain ||
                columnInfo.fileUrlMain ? (
                  <ImgPreview
                    fileUrl={
                      columnInfo.fileUrlMain
                        ? columnInfo.fileUrlMain
                        : imgUrl + columnInfo.thumbnailServerFileNameMain
                    }
                    onClick={() => {
                      delImg("main");
                    }}
                  />
                ) : (
                  <ImgInput
                    id={"file"}
                    accept={"image/*"}
                    onChange={(e) => {
                      inputFile(e, "main");
                    }}
                  />
                )}
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>제목*</DetailFormTitle>
                <MainInput
                  style={{
                    width: "338px",
                  }}
                  type={"text"}
                  placeholder={"제목을(를) 입력해주세요"}
                  value={columnInfo.title}
                  onChange={(e) =>
                    setColumnInfo({ ...columnInfo, title: e.target.value })
                  }
                />
              </DetailPageForm>
              <DetailPageFormCol>
                <DetailFormTitle>내용*</DetailFormTitle>
                <StyledQuillContainer>
                  <TextFormEditor
                    placeholder={"내용을 입력해 주세요."}
                    value={columnInfo.content}
                    onChange={(contents) => {
                      setColumnInfo({
                        ...columnInfo,
                        content: contents,
                      });
                    }}
                    editorHeight={262}
                    style={{
                      width: "964px",
                      marginTop: 6,
                    }}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                  />
                </StyledQuillContainer>
              </DetailPageFormCol>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "30px",
              }}
            >
              <SaveBtn
                onClick={() => {
                  saveBtnHandler();
                }}
              />
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {saveModalOpen ? (
        <Modal
          title={modalMsg.update?.title}
          text={modalMsg.update?.content}
          setModalOpen={setSaveModalOpen}
          onClick={saveFunc}
        />
      ) : null}
    </>
  );
};

export default ColumnPostEdit;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const SelectBoxWrapper = styled.div.attrs((props) => {})`
  width: 338px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 15px;
  border-radius: 4px;
  border: 1px solid #adb4ba;
  background: #fff;
`;

const SubMenuWrapper = styled.div.attrs((props) => {})`
  width: 338px;
  max-height: 200px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 4px 20px 0px rgba(10, 13, 20, 0.15);
  position: absolute;
  top: 50px;
  right: 0;
  padding: 10px;
  overflow-y: auto;
  z-index: 5;

  &::-webkit-scrollbar {
    width: 15px;
  }

  &::-webkit-scrollbar-thumb {
    background: #b0b8c1; /* 스크롤바의 색상 */
    border-radius: 9px;
    background-clip: padding-box;
    border: 6px solid transparent;
  }

  &::-webkit-scrollbar-track {
    background: transparent; /*스크롤바 뒷 배경 색상*/
  }
`;

const SubMenuTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 42px;
  padding: 10px;
  cursor: pointer;
  border-radius: 3px;

  &:hover {
    background-color: #f2f4f5;
  }
`;

const StyledQuillContainer = styled.div`
  //.ql-editor {
  //    padding: 0;
  // }
`;
